import { render } from 'utils/jsx'

import Remote from 'components/Remote'

import Raf from 'controllers/Raf'
import WebSocketServer from 'controllers/WebSocketServer'

///////////////////
////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
//////////

;(async () => {
  render(<Remote />, document.body)
  WebSocketServer.open()
  Raf.start()
})()
